export { default } from "./Workflow";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Workflow/index.js